export const routesMesai = [
  {
    path: "/mesai",
    name: "mesai",
    component: () => import("@/views/mesai/mesai/index.vue"),
    meta: {
      public: false,
      title: "mesai.Mesai",
      yetki: { k: [1012002] },
    },
  },
  
]
